import styled from 'styled-components'

const ContentBox = styled.div`
  border: 1px solid ${({theme}) => theme.colors.border};
  background-color: ${({theme}) => theme.colors.bgPaper};
  color: ${({theme}) => theme.colors.textPrimary};
  border-radius: ${({theme}) => theme.sizes.radii.default};
  padding: ${({theme}) => theme.sizes.boxPadding.y} ${({theme}) => theme.sizes.boxPadding.x};
  box-shadow: ${({theme}) => theme.colors.shadowBox};
  min-width: 0;

  ${({theme}) => theme.breakpoints.down('tablet')} {
    padding-left: 20px;
    padding-right: 20px;
  }
`

export default ContentBox

/*
const BordersEnum = {
  default: colors.border,
  gold: colors.primary,
  dark: colors.primaryDark,
  none: null,
}

const BackgroundsEnum = {
  default: colors.backgroundExtraLight,
  dark: colors.primaryDark,
}

const ContentBox = styled.div(({border, bg, bRadius, withShadow}) => ({
  border: border == null ? 'none' : `1px solid ${border}`,
  backgroundColor: bg,
  borderRadius: bRadius,
  color: bg === BackgroundsEnum.default ? colors.primaryDark : colors.backgroundExtraLight,
  boxShadow: withShadow ? `0px 10px 10px ${colors.shadow}` : 'none',
}))

ContentBox.propTypes = {
  border: PropTypes.oneOf(Object.values(BordersEnum)),
  bg: PropTypes.oneOf(Object.values(BackgroundsEnum)),
  bRadius: PropTypes.string,
  withShadow: PropTypes.bool,
}

ContentBox.defaultProps = {
  border: BordersEnum.default,
  bg: BackgroundsEnum.default,
  bRadius: other.borderRadius.default,
  withShadow: false,
}

export {ContentBox, BordersEnum as boxBorders, BackgroundsEnum as boxBgs}
*/
